import { Button } from "@chakra-ui/button"
import { useDisclosure } from "@chakra-ui/hooks"
import { Flex, HStack } from "@chakra-ui/layout"
import { Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay } from "@chakra-ui/modal"
import { Slider, SliderFilledTrack, SliderTrack } from "@chakra-ui/slider"
import React, { useState } from "react"
import PlayIcon from "../../assets/play-icon.svg"
import Nav from "../layout/Nav"
import ReactPlayer from "react-player"

const content = [
    { bgImage: "bg-image1.png", mobImage: "mob-image1.png", video: "9oX4WX67wE4" },
    { bgImage: "bg-image2.png", mobImage: "mob-image2.png", video: "bN2fdzY6wiE" },
    { bgImage: "bg-image3.png", mobImage: "mob-image3.png", video: "50Yrs2AEp9g" },
]

const Hero = () => {
    const [current, setCurrent] = useState(1)
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <Flex
            w="100%"
            minH={["300px", "500px", "600px", "700px", "100vh"]}
            // minH="100vh"
            // h="100vh"
            direction="column"
            alignItems="center"
            bg="_blue"
            bgImg={[
                `url(${content[current - 1].mobImage})`,
                `url(${content[current - 1].mobImage})`,
                `url(${content[current - 1].bgImage})`,
            ]}
            backgroundSize="cover"
            bgPos="center"
            bgRepeat="no-repeat"
        >
            <Flex
                justify={["space-between"]}
                w="100%"
                minH={["300px", "500px", "600px", "700px", "100vh"]}
                direction="column"
            >
                <Nav />

                <Flex
                    w="100%"
                    justify="center"
                    align="center"
                    pb={["10px", "10px", "37px"]}
                    gridGap={["20px", "40px", "200px"]}
                >
                    <Flex
                        w={["98%", "80%", "90%", "90%", "75%"]}
                        maxW="920px"
                        justify="space-between"
                        background="rgba( 191, 66, 66, 0.25 )"
                        boxShadow="0 8px 32px 0 rgba( 31, 38, 135, 0.37 )"
                        backdropFilter={["blur(1px)", "blur(4px)"]}
                        borderRadius="8px"
                        direction={["column", "column", "row"]}
                        gridGap={["5px"]}
                        align="center"
                        p={["4px", "12px"]}
                    >
                        <HStack
                            spacing={(5, 8)}
                            w={["320px", "100%", "460px", "580px"]}
                            order={["2", "2", "1"]}
                            justify={["space-between", "space-between", "center"]}
                        >
                            <Button
                                variant="noBg"
                                w={["80px", "130px", "130px", "150px"]}
                                visibility={current === 1 ? "hidden" : "unset"}
                                isDisabled={current === 1 ? true : false}
                                onClick={() => setCurrent(current - 1)}
                                cursor="pointer"
                                pointerEvents="all !important"
                                _disabled={{
                                    cursor: "pointer !important",
                                }}
                            >
                                ПРЕТХОДНИ
                            </Button>
                            <Slider
                                aria-label="slider-ex-4"
                                defaultValue={33.4}
                                value={33.4 * current}
                                step={33.4}
                                max={100}
                                w={["100px", "200px", "200px", "300px"]}
                                isReadOnly
                                cursor="unset"
                                size="lg"
                            >
                                <SliderTrack bg="whiteAlpha.400">
                                    <SliderFilledTrack bg="#fff" size="lg" />
                                </SliderTrack>
                            </Slider>
                            <Button
                                variant="noBg"
                                w={["76px", "105px", "115px"]}
                                cursor="pointer"
                                visibility={current === 3 ? "hidden" : "unset"}
                                isDisabled={current === 3 ? true : false}
                                onClick={() => setCurrent(current + 1)}
                                _disabled={{
                                    cursor: "pointer !important",
                                }}
                            >
                                СЛЕДЕЋИ
                            </Button>
                        </HStack>
                        <Button
                            variant="noBg"
                            leftIcon={<PlayIcon height={"30px"} />}
                            onClick={onOpen}
                            order="1"
                        >
                            ПУСТИ ВИДЕО
                        </Button>
                    </Flex>
                </Flex>
                <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
                    <ModalOverlay bg="rgba(23, 18, 10, 0.85)" />
                    <ModalContent>
                        <ModalCloseButton top="-10" bg="#fff" _hover={{ bg: "#fff" }} />
                        <ModalBody pt="56.25%">
                            <ReactPlayer
                                url={`https://youtu.be/${content[current - 1].video}`}
                                style={{ position: "absolute", top: "0", left: "0" }}
                                width="100%"
                                height="100%"
                                controls
                                playing
                                config={{
                                    youtube: {
                                        preload: true,
                                    },
                                }}
                            />
                        </ModalBody>
                    </ModalContent>
                </Modal>
            </Flex>
        </Flex>
    )
}

export default Hero
